import { Injectable } from '@angular/core';
import { TransactionsService } from '../../../transactions/transactions.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { AddTransactionAction, InitTransactionTab } from '../actions/transactions.actions';
import { AlertService } from 'ngx-alerts';
import { Store } from '@ngrx/store';
import {
    EditTransactionFormActions,
    FailEditTransactionForm, OpenEditTransactionModalAction,
    SubmitEditTransactionForm, SuccessEditTransactionForm
} from '../actions/edit-transaction-form.actions';
import { WithdrawAction } from '../models/action.model';
import { ModalService } from '../../../modal/modal.service';

@Injectable()
export class EditTransactionFormSubmitEffects {
    constructor(
        private transactionService: TransactionsService,
        private action$: Actions,
        private alertService: AlertService,
        private store: Store,
        private modalService: ModalService
    ) {
    }

    editTransactionForm$ = createEffect(() =>
        this.action$.pipe(
            ofType<SubmitEditTransactionForm>(EditTransactionFormActions.submitEditTransactionForm),
            switchMap(action =>
                this.transactionService.editWithdrawTransaction(action.payload).pipe(
                    tap((result: WithdrawAction) => {
                        this.store.dispatch(new AddTransactionAction(result, action.payload.transactionId));
                        this.store.dispatch(new InitTransactionTab(action.payload.transactionId));
                        this.alertService.success('Form updated successfully!');
                    }),
                    map(() => new SuccessEditTransactionForm()),
                    catchError((err) => {
                        this.alertService.danger('Something went wrong! :(');
                        return of(new FailEditTransactionForm());
                    })
                )
            )
        )
    );

    openEditModal$ = createEffect(() =>
            this.action$.pipe(
                ofType<OpenEditTransactionModalAction>(EditTransactionFormActions.openEditTransactionModalAction),
                tap((action) => {
                    this.modalService.openEditTransactionModal(action.transactionId);
                }),
            ),
        {dispatch: false}
    );
}
